import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ba-input',
  templateUrl: './ba-input.component.html',
  styleUrls: ['./ba-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BaInputComponent),
      multi: true,
    },
  ],
})
export class BaInputComponent  implements ControlValueAccessor {
  @Input() labelText: string = ''; // Label text
  @Input() labelPosition: 'floating' | 'stacked' | 'fixed' = 'floating'; // Label position
  @Input() type: string = 'text'; // Input type
  @Input() placeholder: string = ''; // Placeholder text
  @Input() disabled: boolean = false; // Disable input

  value: any = ''; // Internal value

  // Callbacks for ControlValueAccessor
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // Update value and emit change
  onInputChange(event: any) {
    const newValue = event.detail.value;
    this.value = newValue;
    this.onChange(newValue);
  }

  // ControlValueAccessor interface methods
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
